module.exports = __webpack_public_path__ + "media/images/feature-4-f15b20c3.png";